import React from 'react';
import { Spinner } from 'reactstrap';
import { useAsync } from 'react-use';
import { format as formatDate } from 'date-fns';

import TenantUserPage from '../hocs/TenantUserPage';
import useAppTitle from '../hooks/useAppTitle';
import useQueryParams from '../hooks/useQueryParams';
import firebase, { functions } from '../../firebase';

const getLectureFrameImages = functions.httpsCallable('getLectureFrameImages');

export default TenantUserPage(function LectureFrameImages(props) {
  const {
    match: {
      params: { eventId },
    },
  } = props;
  const { lectureId, frameIndex } = useQueryParams();

  useAppTitle(['イベント写真']);

  const state = useAsync(async () => {
    const result = await getLectureFrameImages({
      eventId,
      lectureId,
      frameIndex: parseInt(frameIndex),
    });
    return result.data;
  }, [eventId, lectureId, frameIndex]);

  if (state.loading) {
    return (
      <div className="container py-5 text-center">
        <Spinner />
        <p className="mt-3">読み込み中...</p>
      </div>
    );
  }

  if (state.error) {
    return (
      <div className="container py-5">
        <div className="alert alert-danger">{state.error.message}</div>
      </div>
    );
  }

  if (!state.value || !state.value.images || state.value.images.length === 0) {
    return (
      <div className="container py-5">
        <div className="alert alert-info">画像がまだアップロードされていません</div>
      </div>
    );
  }

  const { event, lecture, images } = state.value;
  const frame = lecture.frames?.[frameIndex];

  return (
    <div className="container py-5">
      <h2 className="mb-4">イベント写真</h2>
      <div className="card p-3 mb-4">
        <h5>{event.name}</h5>
        {lecture.date && (
          <p className="mb-1">
            <strong>日付:</strong> {formatDate(new Date(lecture.date), 'yyyy年MM月dd日')}
          </p>
        )}
        {frame && (
          <p className="mb-0">
            <strong>時間:</strong> {formatDate(new Date(frame.startAt), 'HH:mm')} 〜{' '}
            {formatDate(new Date(frame.endAt), 'HH:mm')}
          </p>
        )}
      </div>

      <div className="row">
        {images.map((image, index) => (
          <div key={image.downloadUrl} className="col-md-6 col-lg-4 mb-4">
            <div className="card">
              <a href={image.downloadUrl} target="_blank" rel="noopener noreferrer">
                <img
                  src={image.thumbnailUrl || image.downloadUrl}
                  alt={`Image ${index + 1}`}
                  className="card-img-top"
                  style={{ objectFit: 'cover', height: 300, cursor: 'pointer' }}
                />
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
});
